<template>
  <v-footer app class="pr-4 justify-center white darken3--text">
    <div class="text-center">
      {{ $t("COPY_RIGHT") }}
      © 2023-2024 -
      <a class="mx-2" href="https://www.intlaqcit.com/" target="_blank">{{ $t("CITC") }} </a>
      <a class="mx-2" href="#" @click.prevent="showRefundPolicy = true">{{ $t("REFUND_POLICY") }} </a>
      <a class="mx-2" href="#" @click.prevent="showPrivacyPolicy = true">{{ $t("PRIVACY_POLICY") }} </a>
      <a class="mx-2" href="#" @click.prevent="showTerms = true">{{ $t("TERMS_RULES") }} </a>


      <v-dialog v-model="showPrivacyPolicy" max-width="600px">
        <v-card>
          <v-card-title class="headline">{{ $t("PRIVACY_POLICY_TITLE") }}</v-card-title>
          <v-card-text>
            <v-list dense>
              <v-list-item>
                <v-list-item-content>
                  {{ $t("PRIVACY_POLICY_POINTS.POINT1") }}
                </v-list-item-content>
              </v-list-item>

              <v-list-item>
                <v-list-item-content>
                  {{ $t("PRIVACY_POLICY_POINTS.POINT2") }}
                </v-list-item-content>
              </v-list-item>

              <v-list-item>
                <v-list-item-content>
                  {{ $t("PRIVACY_POLICY_POINTS.POINT3") }}
                </v-list-item-content>
              </v-list-item>

              <v-list-item>
                <v-list-item-content>
                  {{ $t("PRIVACY_POLICY_POINTS.POINT4") }}
                </v-list-item-content>
              </v-list-item>

              <v-list-item>
                <v-list-item-content>
                  {{ $t("PRIVACY_POLICY_POINTS.POINT5") }}
                </v-list-item-content>
              </v-list-item>

              <v-list-item>
                <v-list-item-content>
                  {{ $t("PRIVACY_POLICY_POINTS.POINT6") }}
                </v-list-item-content>
              </v-list-item>
            </v-list>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="primary" text @click="showPrivacyPolicy = false">{{ $t("CLOSE") }}</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>


      <v-dialog v-model="showRefundPolicy" max-width="600px">
        <v-card>
          <v-card-title class="headline">{{ $t("REFUND_POLICY") }}</v-card-title>
          <v-card-text>
            <v-list dense>
              <v-list-item>
                <v-list-item-content>
                  {{ $t("REFUND_POLICY_POINTS.POINT1") }}
                </v-list-item-content>
              </v-list-item>

              <v-list-item>
                <v-list-item-content>
                  {{ $t("REFUND_POLICY_POINTS.POINT2") }}
                </v-list-item-content>
              </v-list-item>

              <v-list-item>
                <v-list-item-content>
                  {{ $t("REFUND_POLICY_POINTS.POINT3") }}
                </v-list-item-content>
              </v-list-item>

            </v-list>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="primary" text @click="showRefundPolicy = false">{{ $t("CLOSE") }}</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>


      <v-dialog v-model="showTerms" max-width="600px">
        <v-card>
          <v-card-title class="headline">{{ $t("TERMS_RULES") }}</v-card-title>
          <v-card-text>
            <v-list dense>
              <v-list-item>
                <v-list-item-content>
                  {{ $t("TERMS_RULES_POINTS.POINT1") }}
                </v-list-item-content>
              </v-list-item>

              <v-list-item>
                <v-list-item-content>
                  {{ $t("TERMS_RULES_POINTS.POINT2") }}
                </v-list-item-content>
              </v-list-item>

              <v-list-item>
                <v-list-item-content>
                  {{ $t("TERMS_RULES_POINTS.POINT3") }}
                </v-list-item-content>
              </v-list-item>

              <v-list-item>
                <v-list-item-content>
                  {{ $t("TERMS_RULES_POINTS.POINT4") }}
                </v-list-item-content>
              </v-list-item>

              <v-list-item>
                <v-list-item-content>
                  {{ $t("TERMS_RULES_POINTS.POINT5") }}
                </v-list-item-content>
              </v-list-item>

              <v-list-item>
                <v-list-item-content>
                  {{ $t("TERMS_RULES_POINTS.POINT6") }}
                </v-list-item-content>
              </v-list-item>
            </v-list>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="primary" text @click="showTerms = false">{{ $t("CLOSE") }}</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <v-bottom-sheet v-model="sheet" inset>

        <!-- TODO: transferede to seperated menu
        <template v-slot:activator="{ on }">
          <a href="#" v-on="on">{{ $t("CONTACT_US") }}</a>
        </template>
        -->
        <v-sheet v-if="getFoundation()==='5'" class="text-center title primary--text">
          <v-container v-if="direction" fill-height fluid>
            <v-row class="headline" justify="center"
            >للتواصل مع مسئولي القبول والتسجيل بالجامعة المصرية للتعلم الإلكتروني الأهلية
            </v-row
            >
            <div class="row title mx-2">
              يمكنكم الاتصال على الأرقام التالية:
            </div>
            <v-list-item-group>
              <v-list-item class="body-4 darken4--text white" disabled>
                02-33318495 <br>
                02-33318481 <br>
                02-33318498
              </v-list-item>
              <v-list-item class="body-4 darken4--text white" disabled>
                أو الاتصال من خلال الخط الساخن 16541 خلال الفترة من 09 صباحا وحتى 09 مساء
              </v-list-item>
            </v-list-item-group>
          </v-container>
          <v-container v-else fill-height fluid>
            <v-row class="headline" justify="center">
              To communicate with the admission and registration officials of the Egyptian E-Learning University
            </v-row>
            <div class="row title mx-2">
              You can call the following numbers:
            </div>
            <v-list-item-group>
              <v-list-item class="body-4 darken4--text white" disabled>
                02-33318495 <br>
                02-33318481 <br>
                02-33318498
              </v-list-item>
              <v-list-item class="body-4 darken4--text white" disabled>
                Or call the hotline 16541 from 09 am to 09 pm
              </v-list-item>
            </v-list-item-group>
          </v-container>
        </v-sheet>

        <v-sheet v-else class="text-center title primary--text">
          <v-container v-if="direction" fill-height fluid>
            <v-row class="headline" justify="center"
            >للتواصل مع مسئولي القبول والتسجيل بجامعة المنصوره الأهلية
            </v-row
            >
            <div class="row title mx-2">
              يمكنكم الاتصال على الأرقام التالية:
            </div>
            <v-list-item-group>
              <v-list-item class="body-4 darken4--text white" disabled>
                01554222502 <br>
              </v-list-item>
              <v-list-item class="body-4 darken4--text white" disabled>
                <!--              أو الاتصال من خلال الخط الساخن 16541 خلال الفترة من 09 صباحا وحتى 09 مساء-->
              </v-list-item>
            </v-list-item-group>
          </v-container>
          <v-container v-else fill-height fluid>
            <v-row class="headline" justify="center">
              To communicate with the admission and registration officials of mansoura University
            </v-row>
            <div class="row title mx-2">
              You can call the following numbers:
            </div>
            <v-list-item-group>
              <v-list-item class="body-4 darken4--text white" disabled>
                <!--              02-33318495 <br>-->
                <!--              02-33318481 <br>-->
                <!--              02-33318498-->
              </v-list-item>
              <v-list-item class="body-4 darken4--text white" disabled>
                <!--                 Or call the hotline 16541 from 09 am to 09 pm-->
              </v-list-item>
            </v-list-item-group>
          </v-container>
        </v-sheet>

      </v-bottom-sheet>
    </div>
  </v-footer>
</template>
<script>
export default {
  data: () => ({
    sheet: false,
    showPrivacyPolicy: false,
    showRefundPolicy: false,
    showTerms: false,

  }),
  computed: {
    direction: function () {
      return this.$store.state.direction;
    },
  },
  methods: {
    getFoundation() {
      return localStorage.getItem("foundationId")
    },
  }
};
</script>
